import React from "react";
import {Tag} from "antd";

export const REPORT_STATUS = {
    PENDING: 'pending',
    STARTED: 'started',
    COMPLETED: 'completed',
    FAILED: 'failed',
};

export function isReportInProgress(status) {
    return status === REPORT_STATUS.PENDING || status === REPORT_STATUS.STARTED;
}

export function reportStatusTag(status) {
    if (status == null) {
        return null;
    }
    if (status === REPORT_STATUS.COMPLETED) {
        return <Tag color={"green"}>completed</Tag>;
    }
    if (status === REPORT_STATUS.FAILED) {
        return <Tag color={"red"}>failed</Tag>;
    }
    if (isReportInProgress(status)) {
        return <Tag color={"blue"}>{status}</Tag>;
    }
    return <Tag>{status}</Tag>;
}
